import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  statusBadge: {
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  statusSuccess: {
    backgroundColor: 'rgba(46, 213, 115, 0.1)',
    color: 'var(--color-success-500)'
  },
  statusError: {
    backgroundColor: 'rgba(255, 71, 87, 0.1)',
    color: 'var(--color-danger-500)'
  },
  statusPending: {
    backgroundColor: 'rgba(255, 193, 7, 0.1)',
    color: 'var(--color-warning-500)'
  }
}))

function StatusBadge ({ status }) {
  const classes = useStyles()

  const getStatusClass = () => {
    switch (status) {
      case 'success':
        return classes.statusSuccess
      case 'error':
        return classes.statusError
      case 'pending':
      default:
        return classes.statusPending
    }
  }

  return (
    <span className={`${classes.statusBadge} ${getStatusClass()}`}>
      {status}
    </span>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['success', 'error', 'pending']).isRequired
}

export default StatusBadge
